import React from 'react';

const ResponsibleGaming = () => {
  return (
      <div className="proskins-content" style={{ padding: 'var(--spacing-lg)', margin: '0px auto' }}>
        <div style={{ marginBottom: 'var(--spacing-sm)' }}>
          
        </div>
        <div className="proskins-card" style={{ marginBottom: 'var(--spacing-2xl)',display: 'flex' }}>
        
          <div className='about-content-container'  style={{marginBottom: 'var(--spacing-sm)', justifyContent: 'space-between'}}>
             <img 
                src="/gambling.jpg" 
                alt="aboutus" 
                className="proskins-image"
              />
            <h1 className="proskins-section-title">Responsible Gambling</h1>
            <p>
            ProSkins.bet is committed to promoting responsible gambling practices. Users are encouraged to set personal limits, manage their time spent on the site, and never wager more than they can afford to lose. If at any time gambling becomes a problem, we recommend seeking assistance from professional support organizations in your jurisdiction. 
            </p>

            <p>
            ProSkins.bet may also provide features to limit deposits, suspend accounts, or self-exclude users who request it in order to maintain healthy betting habits.
            </p>

          </div>
        </div>  
      </div>
  );
};

export default ResponsibleGaming;
